import { ErpPersonService } from './../../../../common/person/service/erp-person-service';
import { Component, OnInit } from '@angular/core';
import { MaritalStatusValue } from './../../../../common/person/model/person-values';
import { WithSuggestionsComponent } from './with-suggestions.component';

@Component( {
    selector: 'erp-pbw-fam-stand',
    templateUrl: './with-suggestions.component.html'
} )
export class MaritalStatusComponent extends WithSuggestionsComponent<MaritalStatusValue> implements OnInit {

    constructor( private readonly personService: ErpPersonService ) {
        super( 'rm.erp.jobapplication.JobApplication.maritalStatus' );
    }

    ngOnInit(): void {
        this.personService.getMaritalStatusValues().subscribe( values => {
            this.unfiltered = values.filter( v => v.relevantForJobApplication );
        } );
    }

    set value( t: MaritalStatusValue | undefined ) {
        if ( this.jobapplication != null ) {
            this.jobapplication.maritalStatus = t;
        }
    }

    get value(): MaritalStatusValue | undefined {
        return this.jobapplication?.maritalStatus;
    }
}
